module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/receipt-dialog/receipt-dialog.component.scss
// module id = 1198
// module chunks = 0